import { createContext, Dispatch, SetStateAction } from "react";

interface ImageContextType {
    imgNumber: number;
    setImgNumber: Dispatch<SetStateAction<number>>;
}

const ImageContext = createContext<ImageContextType | undefined>(undefined)

export default ImageContext;